import styled from "styled-components";
import Calendar from "../components/Event/CalendarComponent";
import EventShow from "../components/Event/EventShow";
import { useRef, useState } from "react";

const Container = styled.div``;

export default function CalendarPage() {
	const [currentSelection, setCurrentSelection] = useState(null);

	const calendarRef = useRef(null);
	const eventShowRef = useRef(null);

	const dateSelectedHandler = (date) => {
		setCurrentSelection(date);
	};

    const bookingDaysChangeHandler = (start, end) => {
        console.log("Days changed: ", start, end);
        
		calendarRef.current.setSelectedDays(start, end);
	};

	return (
		<Container>
			<Calendar ref={calendarRef} onDateSelected={dateSelectedHandler} />
			<EventShow
				ref={eventShowRef}
				event={currentSelection}
				onBookingDaysChange={bookingDaysChangeHandler}
			/>
		</Container>
	);
}
